"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NestedLinkPreparator", {
    enumerable: true,
    get: function() {
        return NestedLinkPreparator;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _dbHelpers = require("~/helpers/dbHelpers");
const _models = require("~/models");
const _addremovelinks = require("~/db/BaseModelSqlv2/add-remove-links");
let NestedLinkPreparator = class NestedLinkPreparator {
    async prepareNestedLinkQb(baseModel, { nestedCols, data, insertObj, req }) {
        const postInsertOps = [];
        const preInsertOps = [];
        const postInsertAuditOps = [];
        for (const col of nestedCols){
            if (col.title in data) {
                const colOptions = await col.getColOptions(baseModel.context);
                const { refContext } = colOptions.getRelContext(baseModel.context);
                const refModel = await _models.Model.get(refContext, colOptions.fk_related_model_id);
                await refModel.getCachedColumns(refContext);
                const refModelPkCol = await refModel.primaryKey;
                const refChildCol = (0, _dbHelpers.getRelatedLinksColumn)(col, refModel);
                // parse data if it's JSON string
                let nestedData;
                try {
                    nestedData = typeof data[col.title] === 'string' ? JSON.parse(data[col.title]) : data[col.title];
                    if (nestedData.length === 0) {
                        continue;
                    }
                } catch (unused) {
                    continue;
                }
                const refBaseModel = await _models.Model.getBaseModelSQL(refContext, {
                    model: refModel,
                    dbDriver: baseModel.dbDriver
                });
                switch(colOptions.type){
                    case _nocodbsdk.RelationTypes.BELONGS_TO:
                        {
                            if (Array.isArray(nestedData)) {
                                nestedData = nestedData[0];
                            }
                            const childCol = await colOptions.getChildColumn(baseModel.context);
                            const parentCol = await colOptions.getParentColumn(baseModel.context);
                            insertObj[childCol.column_name] = (0, _dbHelpers.extractIdPropIfObjectOrReturn)(nestedData, parentCol.title);
                            const refModel = await parentCol.getModel(baseModel.context);
                            postInsertAuditOps.push(async (rowId)=>{
                                await baseModel.afterAddChild({
                                    columnTitle: col.title,
                                    columnId: col.id,
                                    refColumnTitle: refChildCol.title,
                                    rowId,
                                    refRowId: nestedData == null ? void 0 : nestedData[refModelPkCol.title],
                                    req,
                                    model: baseModel.model,
                                    refModel,
                                    refDisplayValue: '',
                                    displayValue: '',
                                    type: _nocodbsdk.RelationTypes.BELONGS_TO
                                });
                                await baseModel.afterAddChild({
                                    columnTitle: refChildCol.title,
                                    columnId: refChildCol.id,
                                    refColumnTitle: col.title,
                                    rowId: nestedData == null ? void 0 : nestedData[refModelPkCol.title],
                                    refRowId: rowId,
                                    req,
                                    model: refModel,
                                    refModel: baseModel.model,
                                    refDisplayValue: '',
                                    displayValue: '',
                                    type: _nocodbsdk.RelationTypes.HAS_MANY
                                });
                            });
                        }
                        break;
                    case _nocodbsdk.RelationTypes.ONE_TO_ONE:
                        {
                            var _col_meta;
                            if (Array.isArray(nestedData)) {
                                nestedData = nestedData[0];
                            }
                            const isBt = (_col_meta = col.meta) == null ? void 0 : _col_meta.bt;
                            const childCol = await colOptions.getChildColumn(baseModel.context);
                            const childModel = await childCol.getModel(baseModel.context);
                            await childModel.getColumns(baseModel.context);
                            let refRowId;
                            if (isBt) {
                                var _nestedData_;
                                // if array then extract value from first element
                                refRowId = Array.isArray(nestedData) ? (_nestedData_ = nestedData[0]) == null ? void 0 : _nestedData_[childModel.primaryKey.title] : nestedData[childModel.primaryKey.title];
                                // todo: unlink the ref record
                                preInsertOps.push(async ()=>{
                                    const res = baseModel.dbDriver(baseModel.getTnPath(childModel.table_name)).update({
                                        [childCol.column_name]: null
                                    }).where(childCol.column_name, refRowId).toQuery();
                                    return res;
                                });
                                const childCol = await colOptions.getChildColumn(baseModel.context);
                                const parentCol = await colOptions.getParentColumn(baseModel.context);
                                insertObj[childCol.column_name] = (0, _dbHelpers.extractIdPropIfObjectOrReturn)(nestedData, parentCol.title);
                            } else {
                                const parentCol = await colOptions.getParentColumn(baseModel.context);
                                const parentModel = await parentCol.getModel(baseModel.context);
                                await parentModel.getColumns(baseModel.context);
                                refRowId = nestedData[childModel.primaryKey.title];
                                postInsertOps.push(async (rowId)=>{
                                    let refId = rowId;
                                    if (parentModel.primaryKey.id !== parentCol.id) {
                                        refId = baseModel.dbDriver(baseModel.getTnPath(parentModel.table_name)).select(parentCol.column_name).where(parentModel.primaryKey.column_name, rowId).first();
                                    }
                                    const linkRecId = (0, _dbHelpers.extractIdPropIfObjectOrReturn)(nestedData, childModel.primaryKey.title);
                                    return baseModel.dbDriver(baseModel.getTnPath(childModel.table_name)).update({
                                        [childCol.column_name]: refId
                                    }).where(childModel.primaryKey.column_name, linkRecId).toQuery();
                                });
                            }
                            postInsertAuditOps.push(async (rowId)=>{
                                await baseModel.afterAddChild({
                                    columnTitle: col.title,
                                    columnId: col.id,
                                    refColumnTitle: refChildCol.title,
                                    rowId,
                                    refRowId: nestedData[refModelPkCol == null ? void 0 : refModelPkCol.title],
                                    req,
                                    model: baseModel.model,
                                    refModel,
                                    refDisplayValue: '',
                                    displayValue: '',
                                    type: _nocodbsdk.RelationTypes.ONE_TO_ONE
                                });
                                await baseModel.afterAddChild({
                                    columnTitle: refChildCol.title,
                                    columnId: refChildCol.id,
                                    refColumnTitle: col.title,
                                    rowId: nestedData[refModelPkCol == null ? void 0 : refModelPkCol.title],
                                    refRowId: rowId,
                                    req,
                                    model: refModel,
                                    refModel: baseModel.model,
                                    refDisplayValue: '',
                                    displayValue: '',
                                    type: _nocodbsdk.RelationTypes.ONE_TO_ONE
                                });
                            });
                        }
                        break;
                    case _nocodbsdk.RelationTypes.HAS_MANY:
                        {
                            if (!Array.isArray(nestedData)) continue;
                            const childCol = await colOptions.getChildColumn(baseModel.context);
                            const parentCol = await colOptions.getParentColumn(baseModel.context);
                            const childModel = await childCol.getModel(baseModel.context);
                            const parentModel = await parentCol.getModel(baseModel.context);
                            await childModel.getColumns(baseModel.context);
                            await parentModel.getColumns(baseModel.context);
                            postInsertOps.push(async (rowId)=>{
                                let refId = rowId;
                                if (parentModel.primaryKey.id !== parentCol.id) {
                                    refId = baseModel.dbDriver(baseModel.getTnPath(parentModel.table_name)).select(parentCol.column_name).where(parentModel.primaryKey.column_name, rowId).first();
                                }
                                return baseModel.dbDriver(baseModel.getTnPath(childModel.table_name)).update({
                                    [childCol.column_name]: refId
                                }).whereIn(childModel.primaryKey.column_name, nestedData == null ? void 0 : nestedData.map((r)=>(0, _dbHelpers.extractIdPropIfObjectOrReturn)(r, childModel.primaryKey.title))).toQuery();
                            });
                            postInsertAuditOps.push(async (rowId)=>{
                                for (const nestedDataObj of Array.isArray(nestedData) ? nestedData : [
                                    nestedData
                                ]){
                                    if (nestedDataObj === undefined) continue;
                                    await baseModel.afterAddChild({
                                        columnTitle: col.title,
                                        columnId: col.id,
                                        refColumnTitle: refChildCol.title,
                                        rowId,
                                        refRowId: nestedDataObj[refModelPkCol == null ? void 0 : refModelPkCol.title],
                                        req,
                                        model: baseModel.model,
                                        refModel,
                                        refDisplayValue: '',
                                        displayValue: '',
                                        type: _nocodbsdk.RelationTypes.HAS_MANY
                                    });
                                    await baseModel.afterAddChild({
                                        columnTitle: refChildCol.title,
                                        columnId: refChildCol.id,
                                        refColumnTitle: col.title,
                                        rowId: nestedDataObj[refModelPkCol == null ? void 0 : refModelPkCol.title],
                                        refRowId: rowId,
                                        req,
                                        model: refModel,
                                        refModel: baseModel.model,
                                        refDisplayValue: '',
                                        displayValue: '',
                                        type: _nocodbsdk.RelationTypes.BELONGS_TO
                                    });
                                }
                            });
                        }
                        break;
                    case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                        {
                            if (!Array.isArray(nestedData)) continue;
                            postInsertOps.push(async (rowId)=>{
                                const parentModel = await colOptions.getParentColumn(baseModel.context).then((c)=>c.getModel(baseModel.context));
                                await parentModel.getColumns(baseModel.context);
                                const parentMMCol = await colOptions.getMMParentColumn(baseModel.context);
                                const childMMCol = await colOptions.getMMChildColumn(baseModel.context);
                                const mmModel = await colOptions.getMMModel(baseModel.context);
                                const rows = nestedData.map((r)=>({
                                        [parentMMCol.column_name]: (0, _dbHelpers.extractIdPropIfObjectOrReturn)(r, parentModel.primaryKey.title),
                                        [childMMCol.column_name]: rowId
                                    }));
                                return baseModel.dbDriver(baseModel.getTnPath(mmModel.table_name)).insert(rows).toQuery();
                            });
                            postInsertAuditOps.push(async (rowId)=>{
                                for (const nestedDataObj of Array.isArray(nestedData) ? nestedData : [
                                    nestedData
                                ]){
                                    if (nestedDataObj === undefined) continue;
                                    await baseModel.afterAddChild({
                                        columnTitle: col.title,
                                        columnId: col.id,
                                        refColumnTitle: refChildCol.title,
                                        rowId,
                                        refRowId: nestedDataObj[refModelPkCol == null ? void 0 : refModelPkCol.title],
                                        req,
                                        model: baseModel.model,
                                        refModel,
                                        refDisplayValue: '',
                                        displayValue: '',
                                        type: _nocodbsdk.RelationTypes.MANY_TO_MANY
                                    });
                                    await baseModel.afterAddChild({
                                        columnTitle: refChildCol.title,
                                        columnId: refChildCol.id,
                                        refColumnTitle: col.title,
                                        rowId: nestedDataObj[refModelPkCol == null ? void 0 : refModelPkCol.title],
                                        refRowId: rowId,
                                        req,
                                        model: refModel,
                                        refModel: baseModel.model,
                                        refDisplayValue: '',
                                        displayValue: '',
                                        type: _nocodbsdk.RelationTypes.MANY_TO_MANY
                                    });
                                }
                            });
                        }
                }
                // update lastModified details in tables
                postInsertAuditOps.push(async (rowId)=>{
                    var _this;
                    await baseModel.updateLastModified({
                        model: baseModel.model,
                        rowIds: [
                            rowId
                        ],
                        cookie: req,
                        updatedColIds: [
                            col.id
                        ]
                    });
                    // Get the corresponding link column ID for the parent table
                    const refTableLinkColumnId = (_this = await (0, _addremovelinks.extractCorrespondingLinkColumn)(baseModel.context, {
                        ltarColumn: col,
                        referencedTable: refBaseModel.model
                    })) == null ? void 0 : _this.id;
                    await refBaseModel.updateLastModified({
                        model: refModel,
                        rowIds: nestedData,
                        cookie: req,
                        updatedColIds: [
                            refTableLinkColumnId
                        ]
                    });
                });
            }
        }
        return {
            postInsertOps,
            preInsertOps,
            postInsertAuditOps
        };
    }
};
